import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { insuranceSelector } from '../../MoneyGuidProSelectors';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { formatNumberLegacy } from '../../../CommonUtils/formatNumberLegacy';
import { ClickableTableRow, HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { useTheme } from '../../../theme/theme';
import { InsuranceDetailsDrawer } from './components/InsuranceDetailsDrawer';
import { Policies } from '../../MoneyGuideProTypes';

export const InsuranceMobile = () => {
  const data = useSelector(insuranceSelector);
  const theme = useTheme();

  const [details, setDetails] = useState<Policies | null>(null);

  if (!data) {
    return null;
  }

  return (
    <>
      <HtmlTable variant="embedded" columnSpacing="small" mt="16">
        <table style={{ tableLayout: 'fixed', width: '100%' }}>
          <colgroup>
            <col width="45%" />
            <col width="45%" />
            <col width="10%" />
          </colgroup>
          {data.policyGroups.map(group => (
            <React.Fragment key={group.groupName}>
              <thead
                style={{ background: theme.colors.neutral['700'], borderColor: 'transparent' }}
              >
                <tr>
                  <th colSpan={3}>
                    <Text
                      color="neutral.600"
                      textAlign="left"
                      fontSize="h6"
                      fontWeight={600}
                      py="16"
                    >
                      {group.groupName}
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {group.policies.map(policy => (
                  <ClickableTableRow
                    variant="clickable"
                    key={policy.description}
                    onClick={() => setDetails(policy)}
                  >
                    <td>
                      <Text fontSize="h5" fontWeight={500} textAlign="left">
                        {policy.description}
                      </Text>
                      <Text fontSize="body" color="neutral.400" textAlign="left">
                        {policy.owner}{' '}
                      </Text>
                    </td>
                    <td>
                      <Text fontSize="h5" fontWeight={500} textAlign="right">
                        {formatNumberLegacy(policy.deathBenefit, {
                          type: 'currency',
                        })}
                      </Text>
                      <Text fontSize="body" color="neutral.400" textAlign="right">
                        Death Benefit
                      </Text>
                    </td>
                    <td>
                      <Icon className="fas fa-chevron-right" fontSize="h6" />
                    </td>
                  </ClickableTableRow>
                ))}
              </tbody>
            </React.Fragment>
          ))}
        </table>
      </HtmlTable>

      {details && <InsuranceDetailsDrawer data={details} onClose={() => setDetails(null)} />}
    </>
  );
};
